import { getPriceLadderSnapshotLevels, type MarketDataSnapshot, type MarketDataSnapshotLevel } from '@talos/kyoko';

export interface PriceLadderLevel {
  bid?: MarketDataSnapshotLevel;
  offer?: MarketDataSnapshotLevel;
}

function hasPrice(level: Partial<MarketDataSnapshotLevel> | undefined): level is MarketDataSnapshotLevel {
  return Boolean(level?.Price);
}

export function getPriceLadderLevels(
  snapshot: MarketDataSnapshot | undefined,
  { depth }: { depth: number }
): PriceLadderLevel[] {
  if (!snapshot) {
    return [];
  }

  return getPriceLadderSnapshotLevels(snapshot, depth).map(level => ({
    bid: hasPrice(level.bid) ? level.bid : undefined,
    offer: hasPrice(level.offer) ? level.offer : undefined,
  }));
}

export function getPriceLadderLevelAtStep(
  snapshot: MarketDataSnapshot | undefined,
  {
    priceStepIndex,
    depth,
  }: {
    priceStepIndex: number;
    depth: number;
  }
): PriceLadderLevel | undefined {
  return getPriceLadderLevels(snapshot, { depth }).at(priceStepIndex);
}
